import React from 'react';

import {I18n} from '@aws-amplify/core';

import {useNavigate} from 'react-router-dom';

import {Center, Stack, Title} from '@mantine/core';

import {ButtonGhostIcon, IconHome16} from 'pac-ux-components';

export const OfflinePage = () => {
    const navigate = useNavigate();

    return (
        <Center>
            <Stack>
                <Title order={1}>{I18n.get('You are offline')}</Title>
                <ButtonGhostIcon
                    type="button"
                    icon={<IconHome16 />}
                    onClick={(event) => {
                        event.preventDefault();
                        navigate('/');
                    }}
                    tabIndex={3}
                >
                    {I18n.get('Home')}
                </ButtonGhostIcon>
            </Stack>
        </Center>
    );
};
